<template>
  <v-navigation-drawer ref="nav" app disable-resize-watcher hide-overlay mobile-break-point="0" :value="isActive" width="500">
    <v-container fluid class="pa-0">
      <v-toolbar flat>
        <v-toolbar-title>Predictivos</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="$store.dispatch('disableControl')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <v-select
              :items="yearDatos"
              v-model="year"
              item-text="translate"
              style="text-transform: capitalize;"
              prepend-inner-icon="calendar_today"
              append-icon="keyboard_arrow_down"
              return-object
              persistent-hint
              :hint="$t('selecciona.anyo')"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container cluid class="pa-0">
        <v-layout row wrap>
          <h4 class="mx-2">{{$t('predictivos.grafica_predictivos')}}</h4>
          <v-flex xs12 class="my-2">
              <v-scale-transition>
                <div id="chart1" ref="grafica1" style="width: 100%;"></div>
              </v-scale-transition>
          </v-flex>

          <h4 class="mx-2">{{$t('predictivos.grafica_historico')}}</h4>
          <v-flex xs12 class="my-2">
              <v-scale-transition>
                <div id="chart2" ref="grafica2" style="width: 100%;"></div>
              </v-scale-transition>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import SourceTileWMS from 'ol/source/tilewms';
import TileLayer from 'ol/layer/tile';
import moment from 'moment';

import Highcharts from 'highcharts';
import setDarkTheme from 'highcharts/js/themes/dark-unica'
import setLightTheme from 'highcharts/js/themes/sand-signika'

import getChart1Config from './charts/chart1';
import getChart2Config from './charts/chart2';

const LayerTemperaturas = new TileLayer({ opacity: 0.7 });

export default {
  props: ['map'],
  data() {
    return {
      id: 'Predictivos',
      year: null,
      chart1: null,
      chart2: null,
      getChart1Config: getChart1Config.bind(this),
      getChart2Config: getChart2Config.bind(this),
    }
  },

  mounted() {
    this.createChart();
  },

  methods: {
    createChart() {
      const chart1Config = this.getChart1Config();
      const chart2Config = this.getChart2Config();
      Highcharts.chart(this.$refs.grafica1, chart1Config, chart => chart.reflow());
      Highcharts.chart(this.$refs.grafica2, chart2Config, chart => chart.reflow());
    },

    onLocaleChange(locale) {
      const months = moment.localeData(locale.key).months().map(m => m.toLowerCase())
      const monthsDisplay = months.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())

      Highcharts.setOptions({
        lang: {
          months: monthsDisplay,
          shortMonths: monthsDisplay.map(str => str.slice(0, 3))
        }
      })

      this.createChart()
    },

    setGraphTheme() {
      const darkTheme = this.$store.getters.isDarkTheme

      if(darkTheme) {
        setDarkTheme(Highcharts)
      } else {
        setLightTheme(Highcharts)
      }
      
      // this.createChart()
    },

    setYear() {
      this.year = this.yearDatos[0];
    },

    setRasterTemperature() {
      LayerTemperaturas.setSource(new SourceTileWMS({
        url: 'https://geoserver.greenurbandata.com/geoserver/valencia/wms',
        params: {
          layers: `predictivos_${this.year}`
        }
      }))
    }
  },
  computed: {
    locale() {
      return this.$store.getters.locale;
    },
    isDarkTheme() {
      return this.$store.getters.isDarkTheme;
    },

    layers() {
      return this.$store.getters.layers;
    },

    rasters() {
      if(!this.layers) {
        return [];
      }

      return this.layers.LayersCS.filter(({ name }) => name.startsWith('predictivos'))
        .sort((a, b) => {
          const yearA = +a.name.replace('predictivos_', '');
          const yearB = +b.name.replace('predictivos_', '');
          return yearA - yearB;
        });
    },

    activeControlId() {
      return this.$store.getters.activeControlId;
    },

    isActive() {
      return (!!this.activeControlId) && this.activeControlId.startsWith(this.id);
    },

    yearDatos() {
      return this.rasters.map(({name}) => +name.replace('predictivos_', ''));
    }
  },

  watch: {
    locale: {
      handler: 'onLocaleChange',
      immediate: false,
    },

    isDarkTheme: {
      handler: 'setGraphTheme',
      immediate: true,
    },
  
    yearDatos: {
      handler: 'setYear',
      immediate: true,
    },

    year: {
      handler: 'setRasterTemperature',
      immediate: true,
    },

    isActive() {
      LayerTemperaturas.setMap(this.isActive ? this.map : null);
      if(this.isActive) {
        this.createChart();
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Predictivos.vue?eba3c1be